import React from 'react'
import {Link} from 'react-router-dom'
import { Image } from 'semantic-ui-react'
import logo from 'assets/images/RDP.png'
import './SessaoExpiradaPage.scss'

export default function SessaoExpiradaPage() {
    return (
        <div id="sessao-expirada" className='d-flex flex-grow-1' >
            <div className="separate">
                <h2>Sessão expirada - Por favor, efetue login no DPNet</h2>
                <h2>Caso o DPNet esteja offline, <Link to="/login">clique aqui</Link></h2>
            </div>
            <Image className='logo' size='small' rounded src={logo} />
        </div>
    )
}
// class="d-flex align-content-between flex-wrap">